import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=d3059bd2"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardAdmin.vue?vue&type=style&index=0&id=d3059bd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports